// Module
var code = "<button class=\"btn btn-default btn-sm\" ng-click=\"vm.cancelOutstandingRequests()\" ng-show=\"vm.cancellers && vm.cancellers.length\"> <i class=\"fa fa-fw fa-ban\"></i> </button>";
// Exports
module.exports = code;